var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeychain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6592,
    y: 17.1202,
    width: 86,
    height: 44,
    rx: 5.5,
    transform: "rotate(15 13.6592 17.1202)",
    stroke: "#039BE5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0838,
    cy: 29.98,
    r: 4.5,
    transform: "rotate(15 21.0838 29.98)",
    stroke: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeychain);
export default ForwardRef;